// Loading states for bridging
export enum CheckoutStatusType {
  CheckingOut = "checking-out",
  CheckingForApproval = "checking-for-approval",
  CheckingForAllowance = "checking-for-allowance",
  RequestingAllowance = "requesting-allowance",
  SettingApproval = "setting-approval",
  BridgingOut = "bridging-out",
  Success = "success",
}
